const access = {
  entities: [
    { label: 't(Workflows)', code: 'workflows' }
  ], 
  rights: [] 
}

export default access
